<p-card>
    <p-toolbar>
            <div class="p-toolbar-group-left">
              <ntap-dynamic [compId]="tableToolbarCompId"></ntap-dynamic>
            </div>
    </p-toolbar>
        <ng-container *ngIf="actions$ | async as actions">
            <ng-container *ngIf="files1$ | async as files">
                <p-tree [propagateSelectionUp]="false" [propagateSelectionDown]="false" [value]="files" selectionMode="checkbox" [(selection)]="selectedFiles"
                    [draggableNodes]="true" [droppableNodes]="true" [validateDrop]="true" (onNodeDrop)="onNodeDrop($event)" draggableScope="self"
                    droppableScope="self" (onNodeExpand)="nodeExpand($event)" (onNodeCollapse)="nodeCollapse($event)" [loading]="(loadingState$ | async) ?? true">
                    
                    <ng-template let-node pTemplate="default">
                        <div>
                            <ng-container ntapListItemProvider [item]="node.data" [listIndex]="node.id">
                                <div class="flex flex-wrap align-items-center justify-content-center">
                                    <span [class]="node.lockedIconClass"></span>
                                    <span class="m-2 vertical-align-middle">{{node.label}}</span>
                                    <div *ngIf="node.selectable">
                                        <ntap-dynamic [compId]="tableToolbarCompId1"></ntap-dynamic>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                        
                    </ng-template>
                    <ng-template let-node pTemplate="url">
                    
                        <button pButton class="custom-button" pRipple type="button" label="Učitaj više"
                        class="mr-2 p-button-info" pTooltip="Učitaj više rezultata." icon="pi pi-arrow-down" (click)="this.loadMore(node)"></button>
                    </ng-template>
                
                </p-tree>
            </ng-container>
        </ng-container>
        <ntap-view-window target="detail" [contentTemplate]="viewWindowContent">

            <ng-template #viewWindowContent let-defaultTemplate>
    
                <ntap-prime-popupview appendTo="body" [modal]="true">
    
                    <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
    
                </ntap-prime-popupview>
    
            </ng-template>
    
        </ntap-view-window>
    <p-toast [preventOpenDuplicates]="true"></p-toast>
</p-card>